import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";
import Header from "./Header";

const BlogPage = lazy(() => import("./BlogPage"));
const BlogPostPage = lazy(() => import("./BlogPostPage"));

const App = () => {
  return (
    <BrowserRouter>
      <Header />
      <Suspense fallback={<div className="page-loading" aria-label="Loading" />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;